import { call, put, takeLatest, cancelled } from "redux-saga/effects"
import axios from "axios"
import { flatMap } from "lodash"
import { getRecommendationsSuccess, getRecommendationsFailed } from "./actions"
import { GET_RECOMMENDATIONS_WATCHER } from "./constants"
import { LOCAL_TOKEN } from "../../../utils/storage"

// Get Companies
function getRecommendationsAPI(params) {
  const url = "recommendations"
  return axios.request({
    method: "GET",
    cancelToken: params.token,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

export function* getRecomendationsSaga(params = false) {
  const cancelSource = axios.CancelToken.source()
  try {
    params.token = cancelSource.token
    const { data } = yield call(getRecommendationsAPI, params)
    data.data.result.recommendations.map((recommendation) => {
      recommendation.dimensions_names = flatMap(
        recommendation.dimensions,
        (e) => e.dimension_name
      ).join()
    })
    const result = {
      recommendations: data.data.result.recommendations,
      dimensions: flatMap(data.data.result.dimensions, (e) => e.dimension_name),
    }
    yield put(getRecommendationsSuccess(result))
  } catch (e) {
    yield put(getRecommendationsFailed())
  } finally {
    if (yield cancelled()) {
      cancelSource.cancel()
      yield put(getRecommendationsFailed())
    }
  }
}

// Individual exports for testing
export default function* recommendationsSaga() {
  yield takeLatest(GET_RECOMMENDATIONS_WATCHER, getRecomendationsSaga)
}
